//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Progress from '@/crowd_fund/ProgressMin'

export default {
    components: { Progress},
    props:['list','acr001'],
    data(){
        return {
            zctoken:'',
            userid:''
        }
    },
    created() {
        
    },
    methods:{
        helpLink(){
            this.$emit('helpLink',this.list)
        }
    },
    mounted(){
    }
}



// WEBPACK FOOTER //
// ./src/crowd_fund/docking/dockingItem.vue